import { Fragment } from 'react';
import { getFieldNameFromLabel } from './suggestion-item-modal.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var formatTemplateWithBlanks = function formatTemplateWithBlanks(template) {
  var formValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!template) return null;
  var parts = template.split(/(\{\{[^}]+\}\}|\n)/g);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: parts.map(function (part, index) {
      if (part === '\n') {
        return /*#__PURE__*/_jsx("br", {}, index);
      }

      var match = part.match(/\{\{([^}]+)\}\}/);

      if (match) {
        var label = match[1];
        var fieldName = getFieldNameFromLabel(label);
        var currentValue = formValues[fieldName];

        if (currentValue !== undefined && currentValue !== null && currentValue !== '') {
          return /*#__PURE__*/_jsx("strong", {
            style: {
              color: 'rgba(0, 123, 255, 0.8)'
            },
            children: currentValue
          }, index);
        }

        return /*#__PURE__*/_jsxs("mark", {
          style: {
            backgroundColor: 'rgba(0, 123, 255, 0.2)',
            color: 'inherit',
            borderRadius: '2px',
            padding: '0 2px'
          },
          children: ["[", label, "]"]
        }, index);
      }

      return /*#__PURE__*/_jsx(Fragment, {
        children: part
      }, index);
    })
  });
};